var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 595,
    height: 951,
    viewBox: "0 0 595 951",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1063 327.054L66.4592 154.845L413.272 193.048L458.432 460.045L97.1063 327.054Z",
    fill: "#019DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M233.157 269.665L496.823 483.57L744.569 311.066L559.087 150.811L233.157 269.665Z",
    fill: "#8EEA36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M658.973 247.474L328.413 476.971L635.479 604.669L776.543 390.503L658.973 247.474Z",
    fill: "#BEAAF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M366.362 279.603L278.194 93.3668L593.964 40.3419L736.911 310.656L366.362 279.603Z",
    fill: "#FF8A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M419.133 791.22L577.709 951L676.786 768.744L547.877 537.473L419.133 791.22Z",
    fill: "#06BF97"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M675.912 502.168L323.784 556.278L492.91 751.69L724.091 604.288L675.912 502.168Z",
    fill: "#FCD300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow1);
export default __webpack_public_path__ + "static/media/Row1.30600560b672f939e04746060bb7fd54.svg";
export { ForwardRef as ReactComponent };